import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Card, CardContent } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Visibility, VisibilityOff, CheckCircle, Cancel } from "@material-ui/icons";
import { TextField, Button, Grid, InputAdornment, IconButton, Typography } from "@material-ui/core";

import api from "../../services/api.js";
import logo from "../../assets/logo.png";

const row_inside_style = { color: '#444', fontSize: 16, marginLeft: "2%" }
const row_style = { width: "90%", flexDirection: 'row', alignItems: 'center', display: 'flex' }

export default function MinhaConta() {
    const { enqueueSnackbar } = useSnackbar();
    const [verSenhaNova, setVerSenhaNova] = useState(false);
    const [password, setRedefinirSenhaNova] = useState("");
    const [confirm_password, setRedefinirSenhaNova2] = useState("");
    const [verSenhaConfirmacao, setVerSenhaConfirmacao] = useState(false);

    /* eslint-disable */
    var hasNumber = /\d/;
    var specialCaracter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    function hasUpperCase(str) {
        return str.toLowerCase() !== str;
    }

    // Função que realiza a alteração de senha
    async function handleAtualizarSenha() {
        enqueueSnackbar("Solicitando alteração de senha", { variant: 'info' })
        const token = document.URL.toString().split("/")[4]
        console.log(token)
        api.put(`/password/reset/${token}`,
            { new_password: password, url: document.URL.toString().split("alterar-a-senha")[0] })
            .then(() => {
                localStorage.setItem("senha", password);
                enqueueSnackbar("Senha alterada, a confirmação foi enviada para o seu e-mail", { variant: 'success' })
            })
            .catch((error) => {
                console.log(error);
                enqueueSnackbar(error.response.data.message, { variant: 'error' })
            });
    }

    return (
        <div className="background">
            <Grid container spacing={0} alignItems="center" justify="center" direction="column" className="full-grid">
                <Card raised className="login-card">
                    <br />
                    <br />

                    <Typography gutterBottom>
                        <img alt="Paeweb" className="login-logo" src={logo} width="180" />
                    </Typography>
                    <CardContent>
                        <div className="titlesSenha">Redefinir senha</div>
                        <FormControl margin="dense" fullWidth={true}>
                            <TextField
                                id="password"
                                type={verSenhaNova ? "text" : "password"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                tabIndex="-1"
                                                aria-label="toggle password visibility"
                                                onClick={() => setVerSenhaNova(!verSenhaNova)}
                                                onMouseDown={(event) => event.preventDefault()}
                                            >
                                                {verSenhaNova ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                size="small"
                                fullWidth={true}
                                label="Informe a nova senha"
                                variant="outlined"
                                onChange={(event) => setRedefinirSenhaNova(event.target.value)}
                            />
                        </FormControl>
                        <FormControl margin="dense" fullWidth={true}>
                            <TextField
                                id="password_confirmation"
                                type={verSenhaConfirmacao ? "text" : "password"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                tabIndex="-1"
                                                aria-label="toggle password visibility"
                                                onClick={() => setVerSenhaConfirmacao(!verSenhaConfirmacao)}
                                                onMouseDown={(event) => event.preventDefault()}
                                            >
                                                {verSenhaConfirmacao ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                size="small"
                                fullWidth={true}
                                label="Confirme a nova senha"
                                variant="outlined"
                                onChange={(event) => setRedefinirSenhaNova2(event.target.value)}
                            />
                        </FormControl>

                        <div style={{
                            fontSize: 16,
                            color: '#444',
                            marginTop: "2%",
                            fontWeight: 'bold',
                        }}
                        >
                            A nova senha deve conter:
                        </div>

                        <div style={row_style}>
                            {
                                password.length > 7
                                    ? <CheckCircle style={{ color: '#2d862d' }} />
                                    : <Cancel style={{ color: '#b30000' }} />
                            }
                            <div style={row_inside_style}>
                                Mínimo de 8 caracteres
                            </div>
                        </div>

                        <div style={row_style}>
                            {
                                hasUpperCase(password)
                                    ? <CheckCircle style={{ color: '#2d862d' }} />
                                    : <Cancel style={{ color: '#b30000' }} />
                            }
                            <div style={row_inside_style}>
                                Letra Maiúscula
                            </div>
                        </div>

                        <div style={row_style}>
                            {
                                hasNumber.test(password)
                                    ? <CheckCircle style={{ color: '#2d862d' }} />
                                    : <Cancel style={{ color: '#b30000' }} />
                            }
                            <div style={row_inside_style}>
                                Números
                            </div>
                        </div>

                        <div style={row_style}>
                            {
                                specialCaracter.test(password)
                                    ? <CheckCircle style={{ color: '#2d862d' }}
                                    />
                                    : <Cancel style={{ color: '#b30000' }} />
                            }
                            <div style={row_inside_style}>
                                Caracteres especiais (Ex: !@#$*)
                            </div>
                        </div>

                        <div style={row_style}>
                            {
                                password === confirm_password && confirm_password !== ""
                                    ? <CheckCircle style={{ color: '#2d862d' }} />
                                    : <Cancel style={{ color: '#b30000' }} />
                            }
                            <div style={row_inside_style}>
                                Duas senhas devem ser iguais
                            </div>
                        </div>

                        <br />
                        <br />
                        <Button
                            id="button_atualizar"
                            disabled={(
                                password.length > 7 &&
                                hasUpperCase(password) &&
                                hasNumber.test(password) &&
                                specialCaracter.test(password) &&
                                password === confirm_password
                            )
                                ? false : true
                            }
                            onClick={handleAtualizarSenha}
                            variant="contained"
                            color="primary"
                            fullWidth={true}
                            size="large"
                            className="btn-login">
                            Atualizar
                        </Button>
                    </CardContent>
                </Card>
            </Grid>
        </div >
    );
}
